import { Button, Popover } from "@mui/material";
import WarningBox from "../Common/WarningBox/WarningBox";
import { LargeModalPDFText } from "constants/text";
import Download from "@mui/icons-material/Download";
import { LargePDFModalWrapper } from "components/ExportFile/LargePDFModal.styles.ts";

interface LargePDFModalProps {
	handleClose: () => void;
	open: boolean;
	popupAnchor?: HTMLElement | null;
	onExportAsExcel?: () => void;
}

const LargePDFModal = ({ handleClose, open, popupAnchor, onExportAsExcel }: LargePDFModalProps) => {
	return (
		<Popover
			open={open}
			anchorEl={popupAnchor}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "right"
			}}
			transformOrigin={{
				vertical: "top",
				horizontal: "right"
			}}
			onClose={handleClose}
			data-testid="order-list-export-large-pdf-modal"
		>
			<LargePDFModalWrapper data-testid="order-list-export-large-pdf-warning">
				<WarningBox
					warning={LargeModalPDFText.LargeFileTitle}
					message={LargeModalPDFText.PDFTooLarge}
				/>
				<div className="body1">
					<p data-testid="order-list-export-large-pdf-proceed-with-csv-prompt">
						{LargeModalPDFText.ProceedWithExcelPrompt}
					</p>
				</div>
				<Button
					onClick={onExportAsExcel}
					data-testid="order-list-large-pdf-modal-export-excel"
				>
					<p>{LargeModalPDFText.ExportExcelOption}</p>
					<Download data-testid="download-excel-export-icon" />
				</Button>
				<Button
					data-testid="order-list-export-large-pdf-close-button"
					onClick={handleClose}
					fullWidth
					variant="outlined"
					sx={{
						margin: ".5rem 0"
					}}
				>
					{LargeModalPDFText.CloseButtonLabel}
				</Button>
			</LargePDFModalWrapper>
		</Popover>
	);
};

export default LargePDFModal;
